export const CLEAR_CART_MENU = 'CLEAR_CART_MENU';
export const GET_CART_MENU = 'GET_CART_MENU';
export const GET_CART_MENU_DONE = 'GET_CART_MENU_DONE';
export const GET_FORMATTED_MENU_LIST = 'GET_FORMATTED_MENU_LIST';
export const GET_FORMATTED_MENU_LIST_DONE = 'GET_FORMATTED_MENU_LIST_DONE';
export const GET_MEMBER_ORDERS_DONE = 'GET_MEMBER_ORDERS_DONE';
export const GET_MENU = 'GET_MENU';
export const GET_MENU_DONE = 'GET_MENU_DONE';
export const GET_MENU_ITEM_DETAILS = 'GET_MENU_ITEM_DETAILS';
export const GET_MENU_LIST = 'GET_MENU_LIST';
export const GET_MENU_LIST_DONE = 'GET_MENU_LIST_DONE';
export const GETTING_CART_MENU = 'GETTING_CART_MENU';
export const GETTING_MENU = 'GETTING_MENU';
export const GETTING_MENU_LIST = 'GETTING_MENU_LIST';
export const SET_ACTIVATED_CATEGORY = 'SET_ACTIVATED_CATEGORY';
export const SET_ACTIVATED_CATEGORY_DONE = 'SET_ACTIVATED_CATEGORY_DONE';
